import React from 'react';
import IMask from 'imask';
import { TextField, TextFieldProps } from '@mui/material';
import { telephoneMasks } from 'utils/telephone';

type PhoneNumberFieldProps = TextFieldProps

export const PhoneNumberField = React.forwardRef<HTMLInputElement, PhoneNumberFieldProps>(function PhoneNumberField({ onChange, ...props }, ref) {
  const phoneMask = IMask.createMask({ mask: telephoneMasks });

  return (
    <TextField
      {...props}
      inputRef={ref}
      onChange={(e) => {
        e.target.value = phoneMask.resolve(e.target.value);

        if (onChange)
          onChange(e);
      }}
    />
  );
});